import { render, staticRenderFns } from "./SearchParams.vue?vue&type=template&id=944b1380"
import script from "./SearchParams.vue?vue&type=script&lang=js"
export * from "./SearchParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports